import { IMetadata, Metadata } from "../metadata/metadata";

export interface IGroupData {
    groupId: number;
    groupName: string;
    enabled: boolean;
    metadata: IMetadata;
    subGroupList: number[];
    parentGroupList: number[];
    productList: any[];
    subGroup?: Map<number, Group>;
}

export interface IGroup extends IGroupData {
    data(): IGroupData
}

export class Group implements IGroup {
    groupId: number;
    groupName: string;
    enabled: boolean;
    metadata: IMetadata;
    subGroupList: number[];
    parentGroupList: number[];
    productList: any[];
    subGroup?: Map<number, Group>;

    constructor(data: IGroupData) {
        this.groupId = data.groupId
        this.groupName = data.groupName
        this.enabled = data.enabled
        this.metadata = new Metadata(data.metadata)
        this.subGroupList = data.subGroupList.map((x) => x)
        this.parentGroupList = data.parentGroupList.map((x) => x)
        this.productList = data.productList.map((x) => x)
        this.subGroup = new Map()
    }

    data(): IGroupData {
        return Object.assign({}, this)
    }
}